import { getFunctions, httpsCallable } from "firebase/functions";
import { parseSquareError } from "./SquareUtils";

// Calls the processScanRefund Firebase Cloud Function
export const processScanRefund = async ({ transactionId, amount, reason, customerId }) => {
  try {
    // Validate inputs
    if (!transactionId || !amount || !reason || !customerId) {
      throw new Error("Invalid transactionId, amount, reason, or customerId");
    }

    const functions = getFunctions();
    const processScanRefundFn = httpsCallable(functions, "processScanRefund");

    // Call the endpoint
    const response = await processScanRefundFn({ transactionId, amount, reason, customerId });
    const data = response.data;

    // Check for success
    if (data.status !== "success") {
      throw new Error("Refund processing failed");
    }

    return {
      refundId: data.refundId,
      transactionId: data.transactionId,
      card: data.card,
      status: data.status,
    };
  } catch (error) {
    // Parse Square-specific errors
    const errorMessage = parseSquareError(error);
    throw new Error(`Refund failed: ${errorMessage}`);
  }
};